
import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import PointList from './List';
import PointAdd from './Add';
import PointDetail from './Detail';


export default class PointRoutes extends Component {
  render() {
    return (
      <Switch>
        <Route path="/point" exact component={PointList} />
        <Route path="/point/add" exact component={PointAdd} />
        <Route path="/point/:id" component={PointDetail} />
      </Switch>
    );
  }
}
